/**
 * @generated SignedSource<<b561a6fbff8d68e3998b293fa89fe739>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FrontPage_page$data = {
  readonly firstGroup: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkGroup_frontGroup" | "LinkListGroup_frontGroup">;
  };
  readonly secondGroup: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkGroup_frontGroup" | "LinkListGroup_frontGroup">;
  };
  readonly thirdGroup: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkGroup_frontGroup" | "LinkListGroup_frontGroup">;
  };
  readonly " $fragmentType": "FrontPage_page";
};
export type FrontPage_page$key = {
  readonly " $data"?: FrontPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"FrontPage_page">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "LinkGroup_frontGroup"
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "LinkListGroup_frontGroup"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FrontPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "firstGroup",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "secondGroup",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "thirdGroup",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FrontPage",
  "abstractKey": null
};
})();

(node as any).hash = "0848de3299d8dd359f747b9ab0abd78f";

export default node;
